import { render, staticRenderFns } from "./DefaultTransactionContent.vue?vue&type=template&id=2b7a0bcc&lang=pug"
import script from "./DefaultTransactionContent.vue?vue&type=script&lang=js"
export * from "./DefaultTransactionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports